import { render, staticRenderFns } from "./EquivalenceAssociationsLayout.vue?vue&type=template&id=b21fdf64"
import script from "./EquivalenceAssociationsLayout.vue?vue&type=script&lang=js"
export * from "./EquivalenceAssociationsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports